
<script>
    import { Bar } from 'vue-chartjs'

    function buildOptions(options, title) {
        // Shallow copy preserves functions (scales callbacks, etc.) in nested objects.
        const merged = Object.assign({}, options || {});

        // Always create a new plugins object (avoid mutating the shared options reference).
        // Unconditionally disable chartjs-plugin-labels and chartjs-plugin-datalabels —
        // bar charts don't need them, and some plugin versions render "100%" as fallback
        // when render returns an empty string.
        merged.plugins = Object.assign({}, merged.plugins || {}, {
            labels: {
                render: function() { return ''; },
                fontSize: 0,
                fontColor: 'rgba(0,0,0,0)'
            },
            datalabels: { display: false }
        });

        merged.title = { display: true, text: title, fontSize: '18' };
        return merged;
    }

    export default {
        extends: Bar,
        name: "FileBarChart",
        props: {
            chartdata: Object,
            options: Object,
            title: String,
            update: Boolean
        },
        mounted() {
            const chartDataCopy = this.chartdata ? JSON.parse(JSON.stringify(this.chartdata)) : null;
            this.renderChart(chartDataCopy, buildOptions(this.options, this.title));
        },
        watch: {
            chartdata: {
                handler(newVal) {
                    if (newVal && newVal.labels && newVal.labels.length > 0) {
                        const chartDataCopy = JSON.parse(JSON.stringify(newVal));
                        this.renderChart(chartDataCopy, buildOptions(this.options, this.title));
                    }
                },
                deep: true,
                immediate: false
            },
            update() {
                const chartDataCopy = this.chartdata ? JSON.parse(JSON.stringify(this.chartdata)) : null;
                this.renderChart(chartDataCopy, buildOptions(this.options, this.title));
            }
        }
    }
</script>

<style scoped>

</style>
